const translations = {
    duplicateError: 'This certification already exists.',
    loadError: 'Applicator pesticide certification could not be loaded.',
    memberConflictError:
        'This change was not saved because this user belongs to more than one organization.',
    save: 'Save Certification',
    saveError: 'Something went wrong. Please try again.',
    title: 'Edit Applicator Certification'
};

export default translations;
